/**
 * Debe ejecutarse antes que zone.js / cualquier import de @angular/*.
 * Con custom-webpack + resolución ESM, el identificador global `ngDevMode` puede
 * no existir en el scope del bundle y provocar ReferenceError en runtime.
 */
const g = globalThis as typeof globalThis & { ngDevMode?: object | boolean };
if (g.ngDevMode === undefined) {
  g.ngDevMode = {};
}
